import { useEffect, useState } from "react";
import axios from "axios";
import { CalendarClock, AlertTriangle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const eur = (v) => `${Number(v || 0).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
const de = (s) => (s ? `${s.slice(8, 10)}.${s.slice(5, 7)}.` : "");

const Zeile = ({ p, ueber }) => (
  <li className="py-2 grid grid-cols-[3rem_1fr_auto] sm:grid-cols-[4.5rem_1fr_auto] gap-2 sm:gap-3 text-sm items-baseline" data-testid={`zv-zeile-${p.rechnungsnummer}-${p.art}`}>
    <span className={ueber ? "text-[#B4502F] font-medium" : "text-stone-500"}>{de(p.faellig)}</span>
    <span className="min-w-0 break-words sm:truncate">
      <span className="font-medium text-stone-900">{p.empfaenger}</span>
      {p.teilnehmer && p.teilnehmer !== p.empfaenger && <span className="text-stone-500"> · TN {p.teilnehmer}</span>}
      <span className="text-stone-400"> · {p.rechnungsnummer} · {p.art}{p.afa ? ` · AfA bis ${de(p.spaetestens)}` : ""}{p.mahnsperre ? " · Mahnsperre" : ""}{p.gesamtfaellig ? " · gesamtfällig" : ""}</span>
    </span>
    <span className="font-semibold tabular-nums text-stone-900">{eur(p.betrag)}</span>
  </li>
);

const Block = ({ titel, summe, liste, ueber, testid }) => {
  const [alle, setAlle] = useState(false);
  const sichtbar = alle ? liste : liste.slice(0, 8);
  return (
    <div className="mt-3" data-testid={testid}>
      <div className="flex items-baseline justify-between border-b border-stone-200 pb-1">
        <span className={`text-xs uppercase tracking-wider ${ueber ? "text-[#B4502F]" : "text-stone-500"}`}>{titel} · {liste.length}</span>
        <span className={`font-semibold tabular-nums ${ueber ? "text-[#B4502F]" : "text-emerald-700"}`} data-testid={`${testid}-summe`}>{eur(summe)}</span>
      </div>
      {liste.length === 0 ? (
        <p className="py-2 text-sm text-stone-500">Keine Posten.</p>
      ) : (
        <ul className="divide-y divide-stone-100">{sichtbar.map((p, i) => <Zeile key={`${p.rechnung_id}-${p.art}-${i}`} p={p} ueber={ueber} />)}</ul>
      )}
      {liste.length > 8 && (
        <button onClick={() => setAlle(!alle)} className="mt-1 text-xs font-medium text-stone-700 hover:underline" data-testid={`${testid}-alle`}>
          {alle ? "Weniger anzeigen" : `Alle ${liste.length} anzeigen`}
        </button>
      )}
    </div>
  );
};

export const Zahlungsvorschau = () => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/rechnungen/zahlungsvorschau?tage=7`).then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d) return null;
  return (
    <div className="mb-6 rounded-xl border border-stone-200 bg-white p-4" data-testid="zahlungsvorschau">
      <div className="flex items-start gap-3">
        <CalendarClock className="h-5 w-5 text-emerald-700 shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-stone-900">Zahlungsvorschau: {de(d.heute)} – {de(d.bis)}</p>
          <p className="text-xs text-stone-600">Erwartete Zahlungen der nächsten 7 Tage. Arbeitsagentur: ab Kursbeginn + 1 Monat (Raten + k Monate), überfällig erst nach 14 Tagen. Als Ausfall markierte Rechnungen zählen nicht.</p>
          <Block titel="Erwartet in den nächsten 7 Tagen" summe={d.kommend_summe} liste={d.kommend} testid="zv-kommend" />
          {d.ueberfaellig.length > 0 && (
            <>
              <div className="mt-4 flex items-center gap-1.5 text-[#B4502F] text-xs"><AlertTriangle size={13} /> Bereits überfällig und noch nicht bezahlt</div>
              <Block titel="Überfällig" summe={d.ueberfaellig_summe} liste={d.ueberfaellig} ueber testid="zv-ueberfaellig" />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
